// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tw-2";
export var chatLink = "_tw-0";
export var chatText = "_tw-1";